<template>
  <v-dialog v-model="dialog" max-width="600" @click:outside="cancel">
    <v-card flat>
      <v-card-title>
        {{ title }}
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pb-0">
        <v-container>
          <v-form ref="form" v-model="valid">
            <v-row>
              <v-col cols="12" class="pb-0">
                <v-text-field
                  v-model="section.title"
                  outlined
                  label="Section Title"
                  :rules="[$rules.required]"
                  maxlength="100"
                  hide-details="auto"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" class="pt-0 pb-6">
                <v-row dense class="subtitle-1 my-auto">
                  <v-spacer></v-spacer>
                  <v-col cols="auto" class="my-auto">
                    <v-checkbox
                      v-model="allMembers"
                      dense
                      hide-details
                      @change="section.teams = []"
                      class="ma-0"
                    >
                      <template v-slot:label>
                        <span class="subtitle-1">All Members</span>
                      </template>
                    </v-checkbox>
                  </v-col>
                </v-row>
                <team-autocomplete
                  v-model="section.teams"
                  label="Departments"
                  v-on:change="updateAllMembers"
                  hide-details="auto"
                ></team-autocomplete>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  outlined
                  v-model="section.description"
                  label="Description (optional)"
                  maxlength="250"
                  hide-details
                  placeholder="Create a description to help your employees better understand the questions in this section"
                >
                </v-textarea>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions class="pt-0">
        <v-btn color="secondary" x-large @click="save" :loading="saving">
          {{ saveText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import TeamAutocomplete from "@/components/teams/TeamAutocomplete";
export default {
  name: "EditAnnualReviewSectionDialog",
  components: { TeamAutocomplete },
  props: {},
  data: () => ({
    dialog: false,
    search: "",
    valid: false,
    loading: false,
    saving: false,
    allMembers: true,
    section: {}
  }),
  watch: {},
  computed: {
    isAdd() {
      return !this.section.id;
    },
    title() {
      return !this.isAdd ? "Edit section" : "Add a new section";
    },
    saveText() {
      return !this.isAdd ? "Save" : "Add Section";
    },
    ...mapGetters({
      annual_review_sections: "settings/annual_review_sections"
    })
  },
  methods: {
    updateAllMembers() {
      this.allMembers = this.section.teams.length == 0;
    },
    cancel() {
      this.dialog = false;
      this.$emit("cancel");
    },
    save() {
      if (this.$refs.form.validate()) {
        this.saving = true;
        this.section.teams = this.section.teams.map(x => ({ id: x.id || x }));
        this.$store
          .dispatch("settings/saveAnnualReviewSection", this.section)
          .then(() => {
            this.$emit("save");

            this.$root.$snackbarSuccess("Section saved");
            this.dialog = false;
          })
          .catch(error => {
            this.logError(error);
            this.$root.$alert(
              "Error Occurred",
              "An error occurred while saving a section."
            );
          })
          .finally(() => {
            this.saving = false;
          });
      }
    },
    showDialog(section) {
      this.dialog = true;
      if (!section || !section.id) {
        section = {
          questions: [],
          sortOrder: this.annual_review_sections.length + 1,
          teams: []
        };
      }
      this.section = this._.cloneDeep(section);
      this.updateAllMembers();
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    }
  }
};
</script>
